
(function () {
    'use strict';

    angular
        .module('virtualFairs')
        .controller('VirtualFairEventSupportController', VirtualFairEventSupportController);
        VirtualFairEventSupportController.$inject = ['VirtualFairService', 'toastr'];
    function VirtualFairEventSupportController(VirtualFairService, toastr) {
        
        var vm = this;

        vm.activate             = activate;
        vm.getByFilter          = getByFilter;
        vm.getAllVirtualFair    = getAllVirtualFair;
        vm.virtualFairSelected  = null;
        vm.email                = null;

        /* PAGINATION */
        vm.pageChanged  = pageChanged;
        vm.setPage      = setPage;
        vm.page         = 1;
        
        function getByFilter () {
            vm.flag = false;
            let query = {};
            query['virtual_fair_id'] = vm.virtualFairSelected;
            query['email'] = vm.email;
            if (vm.page !== null) {
                query['page'] = vm.page;
            }
            VirtualFairService.eventSupport(query).then(function(response) {
                console.log(response);
                vm.queryFlag        = true;
                vm.students         = response.data.data;
                vm.totalItems       = response.data.total;
                vm.itemsPerPage     = response.data.per_page;
                vm.to               = response.data.to;
                vm.setPage(response.data.current_page);
            }).catch(function(err) {
                toastr.error("An error ocurred");
            });
        }

        function getAllVirtualFair () {
            VirtualFairService.getAll().then(function(response) {
                vm.virtualFairs = response.data;
            }).catch(function(err) {
            });
        }

        function activate () {
            // 
            vm.getAllVirtualFair();
        }

        function setPage(page) {
            vm.currentPage = page;
        }

        function pageChanged(page) {
            vm.page = vm.currentPage;
            vm.getByFilter(false);
        }

        vm.activate();
    }
})();